<div class="cards">
  @if (imResults.length > 0) {
    <mat-card appearance="outlined">
      <mat-card-header>
        <h2>IM Results</h2>
      </mat-card-header>
      <mat-card-content>
        <ng-container *ngTemplateOutlet="tableTemplate; context: { rows: imResults }"></ng-container>
      </mat-card-content>
    </mat-card>
  }
  @if (miscCalcs.length > 0) {
    <mat-card appearance="outlined">
      <mat-card-header>
        <h2>EFM Results</h2>
      </mat-card-header>
      <mat-card-content>
        <ng-container *ngTemplateOutlet="tableTemplate; context: { rows: miscCalcs }"></ng-container>
      </mat-card-content>
    </mat-card>
  }
</div>

<div class="cards">
  @for (resultType of resultTypes; track resultType) {
    <div>
      <mat-card appearance="outlined">
        <mat-card-header>
          <h2>{{ resultType.typeName }}</h2>
        </mat-card-header>
        <mat-card-content>
          <ng-container *ngTemplateOutlet="tableTemplate; context: { rows: resultType.displayObjects }"></ng-container>
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>

<ng-template #tableTemplate let-rows="rows">
  <table class="table table-sm" style="width: auto">
    <thead>
      <tr>
        <td style="border: none"></td>
        <th scope="col" class="text-right">Published</th>
        <th scope="col" class="text-right">Draft</th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows; track row) {
        <tr [ngClass]="row.class">
          <th scope="row">{{ row.key }}</th>
          <td [ngClass]="{ different: row.draftValue !== row.publishedValue }" class="text-right">{{ row.publishedValue }}</td>
          <td [ngClass]="{ different: row.draftValue !== row.publishedValue }" class="text-right">{{ row.draftValue }}</td>
        </tr>
        @if (row.class) {
          <tr>
            <td colspan="3">&nbsp;</td>
          </tr>
        }
      }
    </tbody>
  </table>
</ng-template>
